import { cx } from "@suse-o11y/class-variance";
import { Slot, type Slottable } from "@suse-o11y/slot";
import React from "react";

import { useDragHandleProps } from "./context/draggable";
import styles from "./_drag-and-drop.module.css";
import { enable } from "./_enabler";

export interface DragHandleProps extends Slottable, React.HTMLAttributes<HTMLElement> {
	children: React.ReactElement;
}

export const DragHandle = React.forwardRef<React.ComponentRef<"button">, DragHandleProps>(
	({ asChild = false, className, onMouseEnter, ...props }, ref) => {
		const handleProps = useDragHandleProps();

		if (asChild) {
			return (
				<Slot
					ref={ref}
					{...handleProps}
					{...props}
					className={cx(styles.dragHandle, className)}
					onMouseEnter={(event) => {
						enable();
						onMouseEnter?.(event);
					}}
				/>
			);
		}

		return (
			<button
				ref={ref}
				type="button"
				{...handleProps}
				{...props}
				className={cx(styles.dragHandle, className)}
				onMouseEnter={(event) => {
					enable();
					onMouseEnter?.(event);
				}}
			/>
		);
	},
);
